// Third-Party Libraries
import moment from "moment"

// Types
import type { FormType } from "./validationSchema"

export const defaultValues: FormType = {
  coa_cheque_id: "",
  memo: "",
  referensi: "",
  refund_return_detail: [],
  transaction_date: moment().format("YYYY-MM-DD"),
  total_payment:0,
  trx_code:''
}